import { render, staticRenderFns } from "./Slide4.vue?vue&type=template&id=76d774a8&scoped=true&"
import script from "./Slide4.vue?vue&type=script&lang=ts&"
export * from "./Slide4.vue?vue&type=script&lang=ts&"
import style0 from "./Slide4.vue?vue&type=style&index=0&id=76d774a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d774a8",
  null
  
)

export default component.exports